<template>
    <v-container>
        <v-row v-if="hasChanged" class="justify-end">
            <site-button
                btnType="tile"
                colorClasses="calendar-add-btn"
                :colNum="1"
                @click-event="saveChanges"
                toolTip="Save Changes"
                iconString="far fa-save"
            ></site-button>
        </v-row>
        <v-row class="center">
            <v-col cols="12">
                <v-card style="position: relative; overflow: auto;" :height="cardHeight">
                    <h2>{{ partnerName }} Foodie Photos</h2>
                    <v-container>
                        <v-row>
                            <v-col v-for="(photo, index) in photos" :key="index">
                                <image-card
                                    @remove-business-photo="removePhoto"
                                    @update-photo="updatePhoto"
                                    :titleEditor="true"
                                    :index="index" 
                                    :photo="photo.photoData">
                                </image-card>
                            </v-col>
                            <v-col>
                                <image-card
                                    @remove-business-photo="removePhoto"
                                    @add-photo="addPhotos"
                                    :photo="addImagePlaceholder"
                                ></image-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import ImageCard from '../../components/common/ImageCard'

export default {
    components: {
        "image-card": ImageCard
    },
    data: () => ({
        photos: [],
        hasChanged: false
    }),
    methods: {
        saveChanges(){

        },
        addPhotos(files) {
            if (this.photos.length + 1 < 10) {
                for (let i = 0; i < files.length; i++) {
                    const item = files[i]
                    const reader = new FileReader()

                    console.log('add photo: ' + item.name)
                    reader.onload = event => {
                        this.photos.push({
                            photoData: event.target.result,
                            photoFile: item,
                        })
                    }
                    reader.readAsDataURL(item)
                }
            } else {
                alert('maximum photos chosen')
            }
        },
        updatePhoto(updatePhotoObj) {
            console.log(updatePhotoObj.photoFile.name)
            const reader = new FileReader()
            reader.onload = event => {
                this.$set(this.photos, updatePhotoObj.photoIndex, {
                    photoData: event.target.result,
                    photoFile: updatePhotoObj.photoFile,
                })
            }
            reader.readAsDataURL(updatePhotoObj.photoFile)
        },
        removePhoto(index) {
            this.photos.splice(index, 1)
        },
    },
    computed: {
        cardHeight() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return '450'
                default:
                    return '500'
            }
        },
        addImagePlaceholder() {
            return require('../../assets/Add-Image-Placeholder.svg')
        },
        partnerName() {
            if (this.$store.state.partnerData) {
                return this.$store.state.partnerData.partnerName
            } else {
                return ''
            }
        }
    }
}
</script>